import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NoPermissionsSVG from './assets/no_permissions.svg';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	container: {
		textAlign: 'center'
	},
	noPermissionSVG: {
		height: 'auto',
		width: '50%',
		maxWidth: 700,
		marginTop: 50
	}
});

@withStyles(styles)
class NoPermissions extends Component {

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.container}>
				<img
					className={classes.noPermissionSVG}
					src={NoPermissionsSVG}
					alt={localize('no-permissions-admin-only')} />
			</div>
		);
	}

}

NoPermissions.propTypes = {
	classes: PropTypes.object
};


export default NoPermissions;


// WEBPACK FOOTER //
// ./src/containers/NoPermissions/NoPermissions.js